import { createAction, props } from "@ngrx/store";

export const setForm = createAction(
    '[Vehicle form] set form',
    props<{ form: any }>()
);

